<script lang="ts">
  import { deleteSearchQueryStringParameter, setQueryStringParameter } from "../../url";
  import { SearchState } from "../../services/search-service";
  import type { SearchStateModel } from "../../models/search.interface";
  import TooltipHybridButton from "./TooltipHybridButton.svelte";

  export let title: string;
  export let placeholder = "Search";
  export let tooltip = "Enter a search term to do a regular search.";
  export let urlparam: string;


  let collectionSearchInput: string;
  let params = [];

  SearchState.subscribe((search: SearchStateModel) => {
    collectionSearchInput = search.params[urlparam] ? search.params[urlparam].join() : "";
    params = search.params.getAll(urlparam) ? search.params.getAll(urlparam) : [];
  });

  function setNameParam() {
    params.push(collectionSearchInput.trim());
    setQueryStringParameter(urlparam, collectionSearchInput.trim(), true);
  }

</script>
<li class="mb-1">
  <div class="pb-2">
    {title}
    <TooltipHybridButton
      searchUrlQueryParam="name-search"
      tooltip={tooltip}
    />
    <!--    <i-->
    <!--        id="nameToolTip"-->
    <!--        class="bi bi-question-circle-fill"-->
    <!--        aria-label="Name Search Tool Tip"-->
    <!--        aria-describedby="nameSearchToolTipContent"-->
    <!--    ></i>-->
    <!--    <Tooltip id="nameSearchToolTipContent" target="nameToolTip" placement="right" role="tooltip">-->
    <!--      <span>{tooltip}</span>-->
    <!--    </Tooltip>-->
  </div>
  <form on:submit|preventDefault>
    <div class="form-floating margin-2">
      <input type="text"
             class="form-control"
             id="searchFloatingInput"
             placeholder={placeholder}
             bind:value={collectionSearchInput}
             on:change={()=> setNameParam()}
             on:keydown={(e) => {
                       if (e.key === "Enter") {
                           setNameParam();
                       }
                   }}
      >
      <label for="searchFloatingInput">{placeholder}</label>
    </div>
  </form>
  {#if $SearchState.params.has(urlparam)}
    {#each params as p, i}
      <div class="d-flex py-1">
                <span style="overflow-x: hidden; text-overflow: ellipsis"
                      class="badge rounded-pill text-bg-dark pb-0 pe-3 pt-1"
                      role="status"
                      aria-label="name search pill: {p}"
                >
                    <button type="button" class="btn p-0 m-0"
                            on:click={() => deleteSearchQueryStringParameter(urlparam, p)}
                    >
                        <i class="bi bi-x text-bg-dark" aria-label="Delete {p}"></i>
                    </button>
                  {p}
                </span>
      </div>
    {/each}
  {/if}
</li>
<style>
    .badge {
        --bs-badge-padding-y: .10em;

    }
</style>
